import uiTableIcon from './ui-table'
import uiUserLockIcon from './ui-user-lock'
import uiLockIcon from './ui-lock'
import uiOpenLockIcon from './ui-open-lock'
import uiMinusIcon from './ui-minus'
import uiPlusIcon from './ui-plus'
import uiSquareTh from './ui-square-th'
import uiSquareThOne from './ui-square-th-one'
import uiCheckedIcon from './ui-checked'
import uiSuportIcon from './ui-suport'
import uiAllotmentIcon from './ui-allotment'
import uiCloseIcon from './ui-close'
import uiSalesSeries from './ui-sales-series'
import uiWhatsapp from './ui-whatsapp'
import uiEmail from './ui-email'
import uiCredential from './ui-credential'
import uiPhone from './ui-phone'
import uiCircleV from './ui-circle-v'
import uiCircleX from './ui-circle-x'
import uiSpreadsheet from './ui-spreadsheet'
import uiBillIcon from './ui-bill'
import uiBorderTicketIcon from './ui-border-ticket'
import uiCheckIcon from './ui-check'
import uiQrcodeIcon from './ui-qrcode'
import uiXMarkIcon from './ui-x-mark'
import uiDollarCircleIcon from './ui-dollar-circle'
import uiMoneyPrefixIcon from './ui-money-prefix'
import uiEqualsIcon from './ui-equals'
import uiFunnil from './ui-funnil'
import uiUserSearchIcon from './ui-user-search'
import uiDuplicateIcon from './ui-duplicate' 
import '@/assets/styl/icons.styl'

export{
    uiTableIcon,
    uiUserLockIcon,
    uiLockIcon,
    uiOpenLockIcon,
    uiMinusIcon,
    uiPlusIcon,
    uiSquareTh,
    uiSquareThOne,
    uiCheckedIcon,
    uiSuportIcon,
    uiAllotmentIcon,
    uiCloseIcon,
    uiSalesSeries,
    uiWhatsapp,
    uiEmail,
    uiCredential,
    uiPhone,
    uiCircleV,
    uiCircleX,
    uiSpreadsheet,
    uiBillIcon,
    uiBorderTicketIcon,
    uiCheckIcon,
    uiQrcodeIcon,
    uiXMarkIcon,
    uiDollarCircleIcon,
    uiMoneyPrefixIcon,
    uiEqualsIcon,
    uiFunnil,
    uiUserSearchIcon,
    uiDuplicateIcon
}